import styled from 'styled-components';
import { Button, Divider, Space, Spin, Tag } from 'antd';
import { ButtonLabel, ButtonWrapper } from '@src/styles/styled/mixins';

export const PanelWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  position: relative;
  margin: 0;
  padding: 0;
  align-items: center;
`;

export const StyledSpinner = styled(Spin)`
  margin: 0 10px;
  vertical-align: middle;
`;

export const ToolbarWrapper = styled.div`
  .ant-radio-button-wrapper {
    background: transparent !important;
    border: 0;
    border-right: 1px solid #aaa;
    box-shadow: none !important;
    height: 24px;
    line-height: 1.5;

    svg {
      vertical-align: middle;
    }
  }

  .ant-radio-button-wrapper-checked {
    svg path {
      fill: #0046ff;
    }
  }

  .ant-radio-button-wrapper:first-child {
    border-left: 1px solid #aaa;
    border-radius: 0;
  }

  .ant-radio-button-wrapper:last-child {
    border-right: 0;
  }

  .ant-radio-button-wrapper::before {
    background-color: #aaa;
  }
`;

export const StyledResizeWrapper = styled.div`
  ${ButtonWrapper}
`;

export const StyledResizeLabel = styled.div`
  ${ButtonLabel}
`;

export const StyledActionsWrapper = styled.div`
  ${ButtonWrapper}
`;

export const StyledActionsLabel = styled.div`
  ${ButtonLabel}
`;

export const MiddleSpace = styled(Space)`
  padding: 0 10px;
  border-right: 1px solid #e9edf0;
  border-left: 1px solid #e9edf0;
`;

export const IconWrapper = styled.span`
  font-size: 16px;
`;

export const StyledDivider = styled(Divider)`
  margin: 0;
  padding: 0;
`;

export const StyledTag = styled(Tag)`
  font-size: 12px;
  padding: 3px 5px;
  margin: 0;
  background-color: #f5f5f5;
  align-self: center;
  position: relative;

  .anticon {
    font-size: 12px;
  }
`;

export const LayoutBtn = styled(Button)<{ $highlight?: boolean }>`
  font-size: 18px;
  background-color: ${(props) => (props.$highlight ? '#bddffb8a' : 'unset')};
  border: ${(props) => (props.$highlight ? '1px solid #0f93f5' : 'unset')};
  padding: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
`;
